<template>
  <div>
    <b-container fluid class="pb-4 px-0">
      <!-- Toolbar -->
      <div class="dir-toolbar" v-if="items.length || searchQuery">
        <div class="dir-toolbar-search">
          <el-input
            v-model="searchQuery"
            placeholder="Buscar transportista, placa, RUC..."
            suffix-icon="el-icon-search"
            size="small"
            clearable
          />
        </div>
      </div>

      <!-- List -->
      <div v-if="items.length" class="dir-grid-contacts">
        <div
          v-for="(item, index) in items"
          :key="item.id"
          class="dir-contact-card"
          @click="onEdit(item)"
        >
          <div class="dir-card-header">
            <div
              class="dir-card-avatar"
              :style="{ background: getAvatarColor(index) }"
            >
              {{ getInitials(item.name) }}
            </div>
            <div style="flex: 1; min-width: 0">
              <p class="dir-card-name">{{ item.name }}</p>
              <p v-if="item.plate" class="dir-contact-position">
                Placa: {{ item.plate }}
              </p>
            </div>
            <button
              class="btn-remove"
              @click.stop="onDelete(item)"
              title="Eliminar"
            >
              <i class="el-icon-delete"></i>
            </button>
          </div>

          <div v-if="item.document" class="dir-card-meta">
            <i class="el-icon-document"></i>{{ item.document_type }}:
            {{ item.document }}
          </div>
          <div v-if="item.email" class="dir-card-meta">
            <i class="el-icon-message"></i>{{ item.email }}
          </div>
          <div v-if="item.phone" class="dir-card-meta">
            <i class="el-icon-phone-outline"></i>{{ item.phone }}
          </div>
        </div>
      </div>

      <!-- Empty state -->
      <div
        v-if="!items.length && loaded"
        class="wrapper__card-empty-documents d-flex flex-column justify-content-center align-items-center bg-color-write border-radius p-4 m-4"
      >
        <div class="empty-icon-circle">
          <i class="el-icon-truck"></i>
        </div>
        <div class="wrapper__card-empty-info my-2">
          <p class="text-center">No hay transportistas registrados</p>
        </div>
        <div class="wrapper__card-empty-action">
          <ButtonPrimaryComponent
            title="+ Agregar transportista"
            @onSaveClick="openAddDialog"
          />
        </div>
      </div>
    </b-container>

    <!-- Modal crear/editar -->
    <el-dialog
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="() => (dialogVisible = false)"
    >
      <EditCarrierComponent
        v-if="dialogVisible"
        :carrier="selectedCarrier"
        @saved="onSaved"
        @close="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../components/ButtonPrimary";
import EditCarrierComponent from "./EditCarrier";
import businessService from "../services/businessService";

const AVATAR_COLORS = [
  "#3ecfb4",
  "#6366f1",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#06b6d4",
  "#84cc16",
  "#f97316",
  "#ec4899",
  "#14b8a6"
];

export default {
  name: "ListCarriersComponent",
  components: { ButtonPrimaryComponent, EditCarrierComponent },
  data: () => ({
    items: [],
    loaded: false,
    searchQuery: "",
    dialogVisible: false,
    selectedCarrier: {},
    searchTimeout: null
  }),
  watch: {
    searchQuery() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchCarriers(), 400);
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return "?";
      return name
        .split(" ")
        .slice(0, 2)
        .map(w => w[0])
        .join("")
        .toUpperCase();
    },
    getAvatarColor(index) {
      return AVATAR_COLORS[index % AVATAR_COLORS.length];
    },
    openAddDialog() {
      this.selectedCarrier = {};
      this.dialogVisible = true;
    },
    onEdit(carrier) {
      this.selectedCarrier = { ...carrier };
      this.dialogVisible = true;
    },
    async onDelete(carrier) {
      try {
        await this.$confirm(
          `Eliminar transportista "${carrier.name}"?`,
          "Confirmar",
          { type: "warning" }
        );
        await businessService.deleteCarrierId(carrier.id);
        this.fetchCarriers();
      } catch (e) {
        // cancelled
      }
    },
    onSaved() {
      this.fetchCarriers();
    },
    async fetchCarriers() {
      try {
        const response = await businessService.getCarriers({
          params: {
            search: this.searchQuery || undefined,
            per_page: 100
          }
        });
        if (response.data.success) {
          this.items = response.data.carriers;
          this.$emit("update-count", response.data.pagination.total);
        }
      } catch (e) {
        // silent
      } finally {
        this.loaded = true;
      }
    }
  },
  mounted() {
    this.fetchCarriers();
  }
};
</script>

<style lang="scss" scoped>
.btn-remove {
  background: none;
  border: none;
  color: #ccc;
  font-size: 16px;
  cursor: pointer;
  padding: 4px;
  transition: color 0.15s;
  &:hover {
    color: #f56c6c;
  }
}
</style>
